import { render, staticRenderFns } from "./FailedTxnsChart.vue?vue&type=template&id=6029ce8e"
import script from "./FailedTxnsChart.vue?vue&type=script&lang=js"
export * from "./FailedTxnsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports